export enum StorageKeys {
  DISCLAIMER_SHOWN = 'maya_disclaimerShown',
  API_USER = 'lg_api_user',
  API_TOKEN = 'lg_api_token',
  INTROVIDEO_PLAYED = 'maya_introvideo_played'
}
